import { Bid, BonusIndicator, BridgePosition, Call, GamePhase, SeatPosition } from '../../app/types';
import { GameEngine, convertIntToBridgePosition, convertIntToCall, fixColor } from '../game-engine-helper';
import { SFSObject } from 'sfs2x-api';
import { SFSVAR } from '../sfsVar';
import { bridgeWarTitleMap } from '../../app/defaults';
import { getEndOfWarMessage, popMessage, simplePopUp } from '../../utils/shark-helper';
import { modalGameResults } from '../../utils/modal.helper';
import { undoButton } from '../buttonsState';

export function MID_TIME_TO_BID(cmdObj: SFSObject, sender: GameEngine) {
    if (cmdObj.containsKey('highbid') && !cmdObj.containsKey('validbid')) {
        return;
    }
    const player: BridgePosition = convertIntToBridgePosition(cmdObj.getInt(SFSVAR.SFSGAME_CURENT_PLAYER));
    if (sender.props.app.engineStateInterface.isMiniBridge) {
        sender.setSimpleMessage(
            'right',
            'This is a mini bridge game!</br></br>Select a contract from the bidding ladder on the right.',
            undefined,
        );
        return;
    } else if (sender.props.app.engineState.service !== 'BetterBridgeClub') {
        const message = 'Select a call from the Bidding Ladder on the right.';
        sender.setSimpleMessage('right', message, undefined);
        const bid: Bid = {
            bridgePosition: player,
            call: 'q',
            backgroundColor: undefined,
        };
        sender.props.table_setAuction([...sender.props.table.auction, bid]);
    }
    const stake: number = cmdObj.getInt('stake');
    const validCall: number = cmdObj.containsKey('validbid')
        ? cmdObj.getInt('validbid')
        : cmdObj.containsKey('highbid')
        ? cmdObj.getInt('highbid')
        : 0;
    const minCall: Call = validCall === 0 ? ('1c' as Call) : convertIntToCall(validCall);
    sender.props.table_updateBiddingLadder({
        showArrow: true,
        firstVisibleCall: minCall,
        minimalValidCall: minCall,
        isActive: true,
        isVisible: true,
        showBonusIndicator: true,
        bonusIndicators: [BonusIndicator.j, BonusIndicator.m, BonusIndicator.s, BonusIndicator.g],
        stake:
            stake === 4
                ? {
                      backgroundColor: undefined,
                      call: 'rdbl',
                      disabled: false,
                      invisible: false,
                  }
                : {
                      backgroundColor: undefined,
                      call: 'xdbl',
                      disabled: stake !== 2,
                      invisible: false,
                  },
    });

    sender.props.table_updateTable({
        player: player,
    });

    Object.values(sender.props.table.seatData).forEach((value, index) => {
        sender.props.table_setSeatData({
            seatPosition: value.seatPosition ?? SeatPosition.top,
            background: value.bridgePosition === player ? fixColor('y') : undefined,
        });
    });

    sender.showButtonsIfNeeded();
}

export function MID_TIME_TO_BID_SB(cmdObj: SFSObject, sender: GameEngine) {
    sender.props.app_updateEngineInterfaceState({ showWelcome: false });
    sender.waitingForBid = false;
    if (cmdObj.containsKey('highbid') && !cmdObj.containsKey('validbid')) {
        return;
    }
    const player: BridgePosition = convertIntToBridgePosition(cmdObj.getInt(SFSVAR.SFSGAME_CURENT_PLAYER));
    if (sender.props.app.engineStateInterface.isMiniBridge) {
        sender.setSimpleMessage('left', 'This is a mini bridge game!</br></br>Select a contract.', undefined);
        return;
    }
    else {
        const message = 'Select a call from the Bidding Keyboard on the bottom right.';
        sender.setSimpleMessage('left', message, undefined);
        const bid: Bid = {
            bridgePosition: player,
            call: 'q',
            backgroundColor: undefined,
        };
        sender.props.table_setAuction([...sender.props.table.auction, bid]);
    }
    const stake: number = cmdObj.getInt('stake');
    const validCall: number = cmdObj.containsKey('validbid')
        ? cmdObj.getInt('validbid')
        : cmdObj.containsKey('highbid')
        ? cmdObj.getInt('highbid')
        : 0;
    const minCall: Call = validCall === 0 ? ('1c' as Call) : convertIntToCall(validCall);
    sender.props.table_updateBiddingLadder({
        showArrow: true,
        firstVisibleCall: minCall,
        minimalValidCall: minCall,
        isActive: true,
        isVisible: true,
        showBonusIndicator: true,
        bonusIndicators: [BonusIndicator.j, BonusIndicator.m, BonusIndicator.s, BonusIndicator.g],
        stake:
            stake === 4
                ? {
                      backgroundColor: undefined,
                      call: 'rdbl',
                      disabled: false,
                      invisible: false,
                  }
                : {
                      backgroundColor: undefined,
                      call: 'xdbl',
                      disabled: stake !== 2,
                      invisible: false,
                  },
    });

    sender.props.table_updateTable({
        player: player,
    });

    // Object.values(sender.props.table.seatData).forEach((value, index) => {
    //     sender.props.table_setSeatData({
    //         seatPosition: value.seatPosition ?? SeatPosition.top,
    //         background: value.bridgePosition === player ? fixColor('y') : undefined,
    //     });
    // });

    sender.showButtonsIfNeeded();
    const { showWelcome } = sender.props.app.engineStateInterface;
    const atVeryFirstBoard =
        sender.props.table.board.boardNumber === 1 && sender.props.table.tricks[0]?.cardIds.length === 1;
    const atMyFirstBid: boolean = sender.props.table.auction.length < 4;

    const resumeGameSelector = atMyFirstBid
        ?   {
            title: undefined,
            text: sender.props.app.engineStateInterface.lobbyRoom?.getVariable(
                SFSVAR.SFSGAME_ROOM_WELCOME_MESSAGE,
            ).value as string,
            buttonCancel: 'OK',
        }
        : {
            title: 'Welcome back!',
            text: 'It is your turn to make a call',
            buttonCancel: 'Resume Board',
        };
    if (showWelcome) {
        if (atVeryFirstBoard) {
            sender.props.app_addModal(popMessage(resumeGameSelector.text, resumeGameSelector.title, resumeGameSelector.buttonCancel));
        } else {
            //We are resuming a game, this is the first time the user is invited to take action
            sender.props.app_addModal(popMessage(resumeGameSelector.text, resumeGameSelector.title, resumeGameSelector.buttonCancel));
        }
    }
}

export function MID_TIME_TO_BID_BWAR(cmdObj: SFSObject, sender: GameEngine): void {
    const { urlParams } = sender.props.app;
    sender.props.app_updateEngineInterfaceState({ showWelcome: false });
    let gameSelector = undefined;
    if (urlParams?.['mode'] === 'bwar_c_' || urlParams?.['mode'] === 'bwar_dd_') {
        gameSelector = [
            {
                title: bridgeWarTitleMap[urlParams?.['mode']],
                text: sender.props.app.engineStateInterface.lobbyRoom?.getVariable(SFSVAR.SFSGAME_ROOM_WELCOME_MESSAGE)
                    .value as string,
                buttonLabelNext: 'Pick your Journey',
            },
            {
                title: 'Choose Hero Suit or play without',
                buttonLabelBack: 'Back',
                buttonLabelNext: 'Start Duel',
            },
        ];
    } else if (urlParams?.['mode'] === 'bwar_ex_') {
        gameSelector = [
            {
                title: bridgeWarTitleMap[urlParams?.['mode']],
                text: sender.props.app.engineStateInterface.lobbyRoom?.getVariable(SFSVAR.SFSGAME_ROOM_WELCOME_MESSAGE)
                    .value as string,
                buttonLabelNext: 'Pick your Journey',
            },
            {
                title: 'Choose No Hero or Hero Suit',
                buttonLabelBack: 'Back',
                buttonLabelNext: 'Select Stakes',
            },
            {
                title: 'Set Your Stakes',
                text: 'Click/Tap on a level to see trick goal',
                buttonLabelBack: 'Back',
                buttonLabelNext: 'Start Duel',
            },
        ];
    }
    sender.props.table_updateTable({
        bridgeWarGameSelector: gameSelector,
    });
}
